import { useState } from "react";
import { C } from "../constants/colors";
import { TYPE_STYLE } from "../constants/opportunities";
import { OppModal } from "../components/OppModal";

export function SearchScreen({ onBack, bp, opportunities, artists, currentProfile }) {
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("all");
  const [modal, setModal] = useState(null);

  const ALL = [
    ...opportunities.map(o=>({ ...o, _kind:"opportunity" })),
    ...artists.map(a=>({ ...a, _kind:"artist" })),
  ];

  const results = ALL.filter(item=>{
    const kindMatch = filter==="all"
      || (filter==="opportunities" && item._kind==="opportunity")
      || (filter==="artists"       && item._kind==="artist");
    if (!query) return kindMatch;
    const q = query.toLowerCase();
    const haystack = [
      item.title||"", item.name||"", item.org||"",
      item.location||"", item.theme||"", item.bio||"",
      ...(item.mediums||[]),
    ].join(" ").toLowerCase();
    return kindMatch && haystack.includes(q);
  });

  return (
    <div style={{ maxWidth:860,margin:"0 auto",padding:bp==="mobile"?0:"28px 24px 80px" }}>
      {bp !== "mobile" && (
        <button onClick={onBack} style={{ display:"flex",alignItems:"center",gap:6,background:"none",border:"none",color:C.muted,fontFamily:"'DM Mono',monospace",fontSize:".62rem",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:20,padding:0,minHeight:44 }}>← Back</button>
      )}
      <h1 style={{ fontFamily:"'Fraunces',serif",fontSize:"1.7rem",fontWeight:400,color:C.bark,marginBottom:6 }}>Search</h1>
      <p style={{ fontSize:".84rem",color:C.muted,marginBottom:22 }}>Find open calls, artists and galleries across Australia.</p>

      <div className="search-wrap">
        <span className="search-icon">🔍</span>
        <input className="search-input" placeholder="Search opportunities, artists, mediums, locations…" value={query} onChange={e=>setQuery(e.target.value)} autoFocus/>
      </div>

      <div className="filter-bar">
        {[["all","All"],["opportunities","Opportunities"],["artists","Artists"]].map(([v,l])=>(
          <button key={v} className="filter-btn"
            style={{ background:filter===v?C.clay:"none",color:filter===v?"#fff":C.muted,border:filter===v?"none":`1.5px solid ${C.sand}` }}
            onClick={()=>setFilter(v)}>{l}</button>
        ))}
      </div>

      {query&&<div style={{ fontFamily:"'DM Mono',monospace",fontSize:".62rem",color:C.muted,marginBottom:16 }}>{results.length} result{results.length!==1?"s":""} for "{query}"</div>}

      {results.length===0&&query?(
        <div className="empty-state">
          <div style={{ fontSize:"2.5rem",marginBottom:14,opacity:.5 }}>🔍</div>
          <div style={{ fontFamily:"'Fraunces',serif",fontSize:"1.2rem",color:C.bark,marginBottom:8 }}>No results for "{query}"</div>
          <p style={{ fontSize:".82rem",color:C.muted,maxWidth:360,lineHeight:1.7 }}>Try different keywords, or browse by category above.</p>
        </div>
      ):(
        <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
          {results.map((item,i)=>(
            <div key={i} style={{ background:C.cream,border:`1px solid ${C.sand}`,borderRadius:8,padding:"14px 16px",display:"flex",gap:14,alignItems:"center",cursor:"pointer",transition:"transform .15s,box-shadow .15s" }}
              onClick={()=>{
                if (item._kind==="opportunity") {
                  setModal(item);
                } else {
                  // TODO: navigate to artist public profile when route exists
                  console.log('artist id:', item.id);
                }
              }}
              onMouseOver={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 18px rgba(59,47,47,.1)"}}
              onMouseOut={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow=""}}>
              <div style={{ width:44,height:44,borderRadius:8,background:item.color||item._kind==="artist"?"#d4c5a9":"#b5c9b8",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.2rem",flexShrink:0 }}>
                {item._kind==="opportunity"?item.emoji:"👤"}
              </div>
              <div style={{ flex:1,minWidth:0 }}>
                <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:3,flexWrap:"wrap" }}>
                  <span style={{ background:item._kind==="opportunity"?TYPE_STYLE[item.type]?.bg:C.sageL,color:item._kind==="opportunity"?TYPE_STYLE[item.type]?.color:C.sageD,fontFamily:"'DM Mono',monospace",fontSize:".56rem",letterSpacing:"1.5px",textTransform:"uppercase",padding:"2px 8px",borderRadius:"2px",fontWeight:600 }}>
                    {item._kind==="opportunity"?TYPE_STYLE[item.type]?.label:"Artist"}
                  </span>
                </div>
                <div style={{ fontFamily:"'Fraunces',serif",fontSize:".98rem",color:C.bark,marginBottom:2 }}>{item.title||item.name}</div>
                <div style={{ fontSize:".72rem",color:C.muted,fontFamily:"'DM Mono',monospace" }}>
                  {item._kind==="opportunity"?`${item.org} · ${item.deadline}`:`${item.title} · ${item.location}`}
                </div>
              </div>
              <span style={{ color:C.clay,flexShrink:0 }}>→</span>
            </div>
          ))}
        </div>
      )}

      {modal&&<OppModal item={modal} onClose={()=>setModal(null)} currentProfile={currentProfile}/>}
      {!query&&(
        <div style={{ marginTop:32 }}>
          <span className="slbl">Browse by type</span>
          <div style={{ display:"grid",gridTemplateColumns:bp==="mobile"?"1fr 1fr":"repeat(3,1fr)",gap:12 }}>
            {[
              { emoji:"🏛️",label:"Exhibitions",count:opportunities.filter(o=>o.type==="exhibition").length,color:"#e8d5f5",tc:"#5a2d82" },
              { emoji:"💰",label:"Grants",count:opportunities.filter(o=>o.type==="grant").length,color:C.amberL,tc:C.amber },
              { emoji:"🌿",label:"Residencies",count:opportunities.filter(o=>o.type==="residency").length,color:C.sageL,tc:C.sageD },
            ].map(c=>(
              <button key={c.label} onClick={()=>setFilter("opportunities")} style={{ background:C.cream,border:`1px solid ${C.sand}`,borderRadius:8,padding:"18px",textAlign:"center",cursor:"pointer",transition:"all .15s" }}
                onMouseOver={e=>{e.currentTarget.style.borderColor=C.clay;}}
                onMouseOut={e=>{e.currentTarget.style.borderColor=C.sand;}}>
                <div style={{ fontSize:"1.8rem",marginBottom:6 }}>{c.emoji}</div>
                <div style={{ fontFamily:"'Fraunces',serif",fontSize:".95rem",color:C.bark }}>{c.label}</div>
                <div style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",color:c.tc,marginTop:3 }}>{c.count} open</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
